import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "./App.css";

function Home() {
  return (
    <div className="page">
      <h1 className="page-title">Hello World custom domain canary</h1>
      <Navigation />
    </div>
  );
}

function Foo() {
  return (
    <div className="page">
      <h1 className="page-title">Foo custom domain canary</h1>
      <Navigation />
    </div>
  );
}

function Bar() {
  return (
    <div className="page">
      <h1 className="page-title">Bar custom domain canary</h1>
      <Navigation />
    </div>
  );
}

function Navigation() {
  return (
    <nav className="nav">
      <Link className="nav-link" to="/">Home</Link>
      <Link className="nav-link" to="/foo">Foo</Link>
      <Link className="nav-link" to="/bar">Bar</Link>
    </nav>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/foo" element={<Foo />} />
        <Route path="/bar" element={<Bar />} />
      </Routes>
    </Router>
  );
}

export default App;
